module.exports = __webpack_public_path__ + "img/vermont_marathon.0cfaeec8.jpeg";